<template>
    <atomic-layout-section section="pagination">
        <div class="pagination-container">
            <atomic-pager name="pagination"></atomic-pager>
            <atomic-results-per-page class="d-none" choices-displayed="12,30,45"></atomic-results-per-page>
        </div>
    </atomic-layout-section>
</template>

<script>
export default {
    name : "coveo-pagination"
}
</script>

<style lang="scss">
atomic-pager {
    &::part(page-button) {
        --atomic-primary: #c3c3c3;
    }

    &::part(previous-button), &::part(next-button), &::part(page-button) {
        width: 50px;
        height: 50px;
        border: 1px solid #c3c3c3;
    }

    &::part(active-page-button) {
        --atomic-background: #042358;
        --atomic-primary: #fff;
        --atomic-on-background: #fff;

        &:focus-visible {
            background-color: var(--atomic-background);
        }
    }

    &::part(next-button), &::part(previous-button) {
        --atomic-primary: #000;
    }

    &::part(buttons) {
        gap: 0;
    }
}
</style>


// WEBPACK FOOTER //
// src/app/components/hcxf/atomic-pagination.vue